module.exports = __webpack_public_path__ + "img/logo-120x120.ad109b1f.png";